module.exports = __webpack_public_path__ + "static/media/Mission_Icon.33e7bd80.svg";